import { Avatar } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import React from 'react'
import { useSelector } from 'react-redux';
import { red } from '@material-ui/core/colors';


export default function UserAccountAvatar() {

    const reducerUser = useSelector(state => state.reducer_user)
    const { user } = reducerUser;

    return (
        <div>
            {
                user &&
                    user.isAuthenticated ? (
                    <Avatar aria-label="recipe" style={{ backgroundColor: red[500], fontSize: '0' }}>
                        user.picture ?
                        <img src={user.picture} alt="user img" /> :
                        user.name[0]
                    </Avatar>
                ) : (
                    <AccountCircle />
                     )

            }
        </div>
    )
}
